import React, { useContext } from "react";
import ReactAudioPlayer from "react-audio-player";

import twitter from "./twitter.svg";
import styles from "./index.module.css";

import { onShare } from "@/utils";
import { AppContext, NftResData } from "@/views/context";
import { LOCAL_KEY } from "@/App";

const sounds = require("./bgm.mp3");

const cx = require("classnames");

interface GlobalControlProps {
  onSave?: () => void;
}

const GlobalControl: React.FC<GlobalControlProps> = (props) => {
  const audioRef = React.useRef(null);
  const [isPlay, setPlay] = React.useState<boolean>(false);
  const [cls, setCls] = React.useState(styles.rotate_music_paused);
  const { state: nftData } = useContext(AppContext);


  const togglePlay = () => {
    if (!isPlay) {
      // @ts-ignore
      audioRef.current.audioEl.current.play();
      setCls(styles.rotate_music_running);
    } else {
      // @ts-ignore
      audioRef.current.audioEl.current.pause();
      setCls(styles.rotate_music_paused);
    }

    setPlay(!isPlay);
  };

  const onHanleShare = () => {
    const initial = localStorage.getItem(LOCAL_KEY)
    const initialState = initial ? JSON.parse(initial) : nftData;
    onShare(initialState.user.address);
  }

  return (
    <div className={styles.global_control}>
      <ReactAudioPlayer src={sounds} ref={audioRef} loop />
      <div onClick={togglePlay} className={cx(styles.rotate_music, cls)}>
        <img src={require(`./${ isPlay? 'music' : 'music_disable' }.svg`)} alt="" />
      </div>
      <div onClick={onHanleShare}>
        <img src={twitter} alt="" />
      </div>
      {/* <div onClick={onSave}>
        <img src={download} alt="" />
      </div> */}
    </div>
  );
};

export default GlobalControl;
